document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-egho-size-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.eghoSizeOpen);
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
      dialog.addEventListener('close', () => opener.focus(), { once: true });
    }
    return;
  }
  const closer = event.target.closest('[data-egho-size-close]');
  if (closer) closer.closest('dialog').close();
  if (event.target.matches('dialog.egho-size-dialog')) {
    const bounds = event.target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
  }
});
